import React, { SVGProps } from 'react';

export default function CheckCircleIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      {...props}
    >
      <path
        d="M16.85 7.78A7.2 7.2 0 1 1 13.49 3.7"
        stroke="#0B998D"
        strokeWidth="1.4"
        strokeLinecap="round"
      />

      <path
        d="M7.3 9.1L9.8 11.6L16.75 4.65"
        stroke="#0B998D"
        strokeWidth="1.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
